import { Box, DropdownRadioGroup } from '@branch-messenger/willow-ui'
import { ChevronUpDownFilled, Swap } from '@branch-messenger/willow-ui/icons'
import { useSuspenseQuery } from '@tanstack/react-query'
import { useMediaQuery } from '@uidotdev/usehooks'
import { FC } from 'react'
import { useTheme } from 'styled-components'

import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownRadioItem,
} from '@/components/dropdown-menu'
import { OrgAvatar } from '@/components/org-avatar'
import { useSwitchOrganization, workerInfoQueryOptions } from '@/queries/auth'
import { useOrganizationStore } from '@/store/organization/organization'
import { mediaQueries } from '@/styles/media'

export const OrganizationSelector: FC = () => {
  const theme = useTheme()
  const orgId = useOrganizationStore(state => state.orgId)
  const { data } = useSuspenseQuery(workerInfoQueryOptions)
  const isTabletAndDown = useMediaQuery(mediaQueries.tabletAndDown)

  const { mutate: switchOrganization } = useSwitchOrganization()

  if (data.length === 1) return null

  return (
    <DropdownMenu
      dropdownContentProps={{
        align: 'center',
        style: {
          minWidth:
            'min(var(--radix-dropdown-menu-content-available-width), 300px)',
        },
      }}
      showArrow={false}
      trigger={
        <DropdownMenuTrigger
          Icon={isTabletAndDown ? Swap : undefined}
          {...(!isTabletAndDown && {
            variant: 'pill',
            color: 'tertiary',
            iconRight: <ChevronUpDownFilled />,
            iconLeft: <Swap />,
            children: 'Switch Company',
          })}
        />
      }
    >
      <DropdownRadioGroup
        value={orgId}
        onValueChange={async value => {
          switchOrganization(value)
        }}
      >
        {data.map(({ org_uuid, org_name, logo_url }) => (
          <DropdownRadioItem
            key={org_uuid}
            value={org_uuid}
            style={{ padding: `${theme.space[2]} ${theme.space[4]}` }}
          >
            <Box $display="flex" $gap={2}>
              <OrgAvatar orgName={org_name} logoUrl={logo_url} />
              {org_name}
            </Box>
          </DropdownRadioItem>
        ))}
      </DropdownRadioGroup>
    </DropdownMenu>
  )
}
